const AccountSubmissionsGridComponent = {
    templateUrl: '/content/accountSubmissionsGrid/accountSubmissionsGrid.tpl.html',
    controller: 'accountSubmissionsGridController',
    bindings: {
        isColumnFilterVisible: '<?',
        isGridFilterVisible: '<?',
        isViewActiveVisible: '<?',
        isSearchVisible: '<?',
        isGridPagingVisible: '<?',
        isGridInteractable: '<?',
        accountId: '<',
        accountNumber: '<',
        isShowCheckboxes: '<?',
        gridColumnsPreference: '<?',
        onSelectedSubmissionsChanged: '&',
        doPoliciesExistOnSubmissions: '&'
    }
};

angular.module('gw-um-submission')
    .component('uiAccountSubmissionsGrid', AccountSubmissionsGridComponent);
